import React from "react";
import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { useSelector } from "react-redux";

import { darkTheme, lightTheme } from "./Theme";
import { getSettingState } from "../../redux/features/settingSlice";
import "../../styles/index.scss";

function ConfigTheme({ children }) {
  const { darkMode } = useSelector(getSettingState);
  const mainTheme = darkMode ? darkTheme : lightTheme;

  return (
    <ThemeProvider theme={mainTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}

export default ConfigTheme;
